import React from 'react'
import Hero from './components/Hero'
import JoinOurTeam from './components/JoinOurTeam'
import MeetTeam from './components/MeetTeam'

const AboutUs = () => {
  return (
   
    <>
    <Hero/>
    <MeetTeam/>
    <JoinOurTeam/>
    </>
  )
}

export default AboutUs